import styled from 'styled-components';
import Menu from '@mui/material/Menu';

export const ProfileMenu = styled(Menu)`
  & .MuiMenu-paper {
    background-color: transparent;
    top: 65px;
  }
  & .MuiList-root {
    padding: 0px;
  }
  & .MuiMenuItem-root {
    padding: 0px;
    background-color: transparent;
  }
  & .MuiPaper-root {
    margin-top: 0.5rem;
  }
`;
